import { SHOW_TOAST, REMOVE_TOAST } from '../actions/types';

const defaultState = {
  status: '',
  toastQueue: []
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case SHOW_TOAST: {
      return {
        ...state,
        status: SHOW_TOAST,
        toastQueue: [...state.toastQueue, action.config]
      };
    }
    case REMOVE_TOAST:
      return {
        ...state,
        status: REMOVE_TOAST,
        toastQueue: state.toastQueue.slice(1)
      };
    default:
      return state;
  }
}
